import React, { useState, useEffect } from "react";
import Datepicker from "../datepicker/Datepicker";
import {
  AddregButton,
  FilterIcon,
  SyncButton,
  UploadFileButton,
} from "../button/Button";

import SyncPopup from "../SyncButton/SyncButton";
import UploadExcelModal from "../common/UploadExcelModal/UploadExcelModal";
import CustomFilter from "../filterIcon/CustomFilter";
import AddFixedAssetRegister from "../forms/AddFixedAssetsRegister/AddFixedAssetRegister";
import UploadfaFile from "../forms/UploadfaFile/UploadfaFile";
import FaUploadedFiles from "../forms/FaUploadedFiles/faUploadedFile";
import ColumnMapping from "../forms/ColumnMappingForm/ColumnMapping";
import Submapping from "../forms/SubMapping/Submapping";
import ERPModal from "../common/ERPModal/ERPModal";
import SyncERPSuccess from "../SyncButton/SyncERPSuccess";
import AppendReplaceFile from "../common/AppendReplacePopup/AppendReplacePopup";
import {
  fixedAssetListing,
  getAllFixedAssetsErpData,
  putFixedAssetFromERP,
} from "../../../Bookclosure/Services/ApiHandler";
import { GetFixedAsset } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import ErrorPopup from "../../elements/ErrorPopup";
import SuccessPopup from "../../elements/SuccessPopup";
import DeletePopup from "../../elements/DeletePopup";

import styles from "./FaHeaders.module.css";

const FaHeaders = ({
  fixedAssetID,
  setFixedAssetID,
  setShowDataState,
  tableType,
  setTableType,
  setShowTable,
  onFiltersApplied,
  showAddRegisterModal,
  setShowAddRegisterModal,
  appliedFilters: parentAppliedFilters,
}) => {
  const [asOnDate, setAsOnDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [showSubmapping, setShowSubmapping] = useState(false);
  const [showUploadExcelModal, setShowUploadExcelModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showFaUploadedFiles, setShowFaUploadedFiles] = useState(false);
  const [showColumnMapping, setShowColumnMapping] = useState(false);
  const [showSubMapping, setShowSubMapping] = useState(false);
  const [showERPModal, setShowERPModal] = useState(false);
  const [showERPSuccessModal, setShowERPSuccessModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(parentAppliedFilters || []);
  const [showPopup, setShowPopup] = useState(false);
  const [showAppendReplacePopup, setShowAppendReplacePopup] = useState(false);
  const [erpList, setErpList] = useState([]);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [isErpLoading, setIsErpLoading] = useState(false);
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, title: "Error", message: "" });
  const [successPopup, setSuccessPopup] = useState({ isOpen: false, title: "Success", message: "" });
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, title: "Are you sure?", message: "", fileIndex: null });

  useEffect(() => {
    if (parentAppliedFilters !== undefined) {
      setAppliedFilters(parentAppliedFilters);
    }
  }, [parentAppliedFilters]);

  const [uploadAction, setUploadAction] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadType, setUploadType] = useState(null);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);

  const [filterConfig, setFilterConfig] = useState([]);

  const formatDateInputValue = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return !isNaN(date.getTime()) ? date.toISOString().split("T")[0] : "";
  };

  const resolveAsOnDateFromItems = (items, id) => {
    if (!Array.isArray(items)) return "";
    const match = items.find(
      (item) =>
        item &&
        (item._id === id ||
          item.id === id ||
          item.saleID === id ||
          item.purchaseID === id ||
          item.fixedAssetID === id)
    );
    if (match?.createdAt) {
      return formatDateInputValue(match.createdAt);
    }
    const firstCreatedAt = items.find((item) => item?.createdAt)?.createdAt;
    return formatDateInputValue(firstCreatedAt);
  };

  useEffect(() => {
    const fetchFilterConfig = async () => {
      try {
        if (!fixedAssetID) return;

        const savedTableType = sessionStorage.getItem(`tableType_${fixedAssetID}`);
        if (savedTableType) {
          setShowTable(true);
          setShowDataState(false);
          setTableType(savedTableType);
        }

        const response = await fixedAssetListing(fixedAssetID, {
          page: 1,
          pageSize: 30,
          filters: [],
        });

        if (response.data && response.data.filterAndAlignment) {
          setFilterConfig(response.data.filterAndAlignment);
        }
        if (response.data?.fixedAssetListing?.length > 0) {
          setShowTable(true);
          setShowDataState(false);
          if (!savedTableType) {
            setTableType("excel");
            sessionStorage.setItem(`tableType_${fixedAssetID}`, "excel");
          }
        } else if (!savedTableType) {
          try {
            const erpRes = await getAllFixedAssetsErpData(fixedAssetID);
            const list =
              erpRes.data?.ERPFixedAssetList ||
              erpRes.data?.data ||
              (Array.isArray(erpRes.data) ? erpRes.data : []);
            if (list && list.length > 0) {
              setShowTable(true);
              setShowDataState(false);
              setTableType("erp");
              sessionStorage.setItem(`tableType_${fixedAssetID}`, "erp");
            }
          } catch (e) {
            // ignore
          }
        }
      } catch (error) {
        console.error("Failed to fetch filter config:", error);
      }
    };

    const fetchAsOnDate = async () => {
      if (!fixedAssetID) {
        setAsOnDate(new Date().toISOString().split("T")[0]);
        return;
      }

      try {
        const response = await GetFixedAsset();
        const assets = response.data?.fixedAssets || response.data?.fixedAsset || response.data?.result || [];
        const dateFromAssets = resolveAsOnDateFromItems(assets, fixedAssetID);
        if (dateFromAssets) {
          setAsOnDate(dateFromAssets);
          return;
        }

        const listingDate = formatDateInputValue(response.data?.fixedAssetListing?.[0]?.createdAt);
        setAsOnDate(listingDate || new Date().toISOString().split("T")[0]);
      } catch (error) {
        console.error("Failed to fetch fixed asset createdAt:", error);
        setAsOnDate(new Date().toISOString().split("T")[0]);
      }
    };

    if (fixedAssetID) {
      fetchFilterConfig();
      fetchAsOnDate();
    }
  }, [fixedAssetID]);

  const handleApplyFilter = (filters) => {
    console.log("Filters received:", filters);
    setAppliedFilters(filters);
    setShowFilter(false);

    if (onFiltersApplied) {
      onFiltersApplied(filters);
    }
  };

  const handleSelect = async (type) => {
    if (type === "uploadExcelModal") {
      setShowAddRegisterModal(false);
      setShowUploadExcelModal(true);
    } else if (type === "erp") {
      setShowAddRegisterModal(false);
      setShowERPModal(true);
      setIsErpLoading(true);
      try {
        let resolvedFixedAssetID = fixedAssetID;
        if (!resolvedFixedAssetID) {
          const response = await GetFixedAsset();
          const assets =
            response.data?.fixedAssets ||
            response.data?.fixedAsset ||
            response.data?.result ||
            [];
          const assetArray = Array.isArray(assets) ? assets : [assets];
          if (assetArray.length > 0 && assetArray[0]) {
            resolvedFixedAssetID =
              assetArray[0]._id || assetArray[0].id || assetArray[0].fixedAssetID;
          }
        }
        const res = await getAllFixedAssetsErpData(resolvedFixedAssetID);
        const list =
          res.data?.ERPFixedAssetList ||
          res.data?.ERPFixedAssetsList ||
          res.data?.data ||
          (Array.isArray(res.data) ? res.data : []);
        if (list && list.length > 0) {
          setErpList(list);
        } else {
          setErpList([
            {
              _id: "5eed000000000000000000d5",
              name: "Sample Fixed Asset ERP Package",
              createdAt: new Date().toISOString(),
              userName: "Admin",
            },
          ]);
        }
      } catch (error) {
        console.error("Failed to fetch ERP fixed assets:", error);
        setErpList([
          {
            _id: "5eed000000000000000000d5",
            name: "Sample Fixed Asset ERP Package",
            createdAt: new Date().toISOString(),
            userName: "Admin",
          },
        ]);
      } finally {
        setIsErpLoading(false);
      }
    }
  };

   const handleChangeFile = () => {
    setShowUploadExcelModal(true);
    setShowUploadFileModal(false);
  }

  const handleSelectUploadType = (type) => {
    setUploadType(type);
    setShowUploadExcelModal(false);
    setShowUploadFileModal(true);
  };

  const handleAddFiles=() => {
    setShowUploadFileModal(true);
    setShowFaUploadedFiles(false);
  }

  const handleProceedToFaUploadedFiles = (files) => {
    const normalized = (files || []).map((file) => {
      const computedName =
        file?.name ||
        file?.fileName ||
        file?.originalname ||
        file?.displayName ||
        file?.file?.name ||
        file?.file?.fileName ||
        file?.file?.originalname ||
        "Untitled file";

      return {
        rawFile: file,
        displayName: computedName,
        isMapped: false,
      };
    });
    setUploadedFiles((prev) => [...prev, ...normalized]);
    setShowUploadFileModal(false);
    setShowFaUploadedFiles(true);
  };

  const handleStartMapping = (index) => {
    setSelectedFileIndex(index);
    setShowFaUploadedFiles(false);
    setShowColumnMapping(true);
  };

  const handleResetMapping = (index) => {
    setUploadedFiles((prev) =>
      prev.map((file, idx) =>
        idx === index ? { ...file, isMapped: false } : file
      )
    );
  };

  const handleContinueMapping = () => {
    setShowColumnMapping(false);
    setShowSubMapping(true);
  };

  const handleSubmappingSuccess = () => {
    if (selectedFileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.map((file, idx) =>
          idx === selectedFileIndex ? { ...file, isMapped: true } : file
        )
      );
    }

    setShowSubMapping(false);
    setShowFaUploadedFiles(true);
  };

  const handleSubmitSubMapping = () => {
    setShowSubMapping(false);
    setShowFaUploadedFiles(true);
  };

  const handleFinish = () => {
    const canFinish = uploadedFiles.some((file) => file.isMapped);
    if (!canFinish) {
      setErrorPopup({
        isOpen: true,
        title: "Mapping Required",
        message: "Please map at least one file before finishing.",
      });
      return;
    }
    setShowFaUploadedFiles(false);
    setShowDataState(false);
    setTableType("excel");
    setShowTable(true);
    if (fixedAssetID) {
      sessionStorage.setItem(`tableType_${fixedAssetID}`, "excel");
    }
  };

  const canFinish = uploadedFiles.some((file) => file.isMapped);

  const handleSuccessERPModal = async () => {
    if (!selectedCardId) {
      setErrorPopup({
        isOpen: true,
        title: "Selection Required",
        message: "Please select an ERP package to proceed.",
      });
      return;
    }
    try {
      let resolvedFixedAssetID = fixedAssetID;
      if (!resolvedFixedAssetID) {
        const response = await GetFixedAsset();
        const assets =
          response.data?.fixedAssets ||
          response.data?.fixedAsset ||
          response.data?.result ||
          [];
        const assetArray = Array.isArray(assets) ? assets : [assets];
        if (assetArray.length > 0 && assetArray[0]) {
          resolvedFixedAssetID =
            assetArray[0]._id || assetArray[0].id || assetArray[0].fixedAssetID;
        }
      }
      const selectedItem = (erpList || [])
        .flatMap((pkg, pkgIdx) => {
          if (Array.isArray(pkg.data) && pkg.data.length > 0) {
            return pkg.data.map((entry, entryIdx) => ({
              ...entry,
              _id: entry._id || `${pkg._id || pkgIdx}-${entryIdx}`,
              packageId: pkg._id || pkg.id,
            }));
          }
          return [pkg];
        })
        .find(
          (i) =>
            i._id === selectedCardId ||
            i.packageId === selectedCardId ||
            i.id === selectedCardId
        );

      const resolvedPackageId =
        selectedItem?.packageId || selectedItem?._id || selectedCardId;

      await putFixedAssetFromERP(resolvedFixedAssetID, resolvedPackageId);
      setShowERPModal(false);
      setSelectedCardId(null);
      setShowERPSuccessModal(true);
    } catch (error) {
      console.error("Failed to pull from ERP:", error);
      setErrorPopup({
        isOpen: true,
        title: "Error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to pull ERP data. Please try again.",
      });
    }
  };

  const handleRemoveFile = (index) => {
    const file = uploadedFiles[index];
    const fileName =
      file?.displayName ||
      file?.name ||
      file?.fileName ||
      file?.originalname ||
      file?.rawFile?.name ||
      "this file";
    setDeletePopup({
      isOpen: true,
      title: "Are you sure?",
      message: `Once deleted, you will not be able to recover "${fileName}"!`,
      fileIndex: index,
    });
  };

  const handleConfirmDeleteFile = () => {
    if (deletePopup.fileIndex !== null) {
      setUploadedFiles((prev) =>
        prev.filter((_, i) => i !== deletePopup.fileIndex)
      );
    }
    setDeletePopup({
      isOpen: false,
      title: "Are you sure?",
      message: "",
      fileIndex: null,
    });
  };

  const handleERPComplete = () => {
    setShowERPSuccessModal(false);
    setShowDataState(false);
    setTableType("erp");
    if (fixedAssetID) {
      sessionStorage.setItem(`tableType_${fixedAssetID}`, "erp");
    }
    setShowTable(false);
    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const handleAppendReplaceSelect = (action) => {
    setUploadAction(action);
    setShowAppendReplacePopup(false);
    setShowUploadExcelModal(true);
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.rightSection}>
          <FilterIcon onClick={() => setShowFilter(true)} />

          <Datepicker
            date={asOnDate}
            onChange={(e) => setAsOnDate(e.target.value)}
            label="As on "
          />

          {/* {tableType === "erp" && (
            <SyncButton onClick={() => setShowPopup(true)} />
          )} */}
          {tableType === "erp" && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
          {tableType === "excel" && (
            <UploadFileButton onClick={() => setShowAppendReplacePopup(true)} />
          )}
          {tableType === null && (
            <AddregButton onClick={() => setShowAddRegisterModal(true)} />
          )}
        </div>
      </div>

      {showAddRegisterModal && (
        <AddFixedAssetRegister
          onClose={() => setShowAddRegisterModal(false)}
          handleSelect={handleSelect}
        />
      )}

      {showUploadExcelModal && (
        <UploadExcelModal
          onClose={() => setShowUploadExcelModal(false)}
          onBack={() => {
            setShowUploadExcelModal(false);
            setShowAddRegisterModal(true);
          }}
          onSelectUploadType={handleSelectUploadType}
        />
      )}

      {showUploadFileModal && (
        <UploadfaFile
          FixedAssetID={fixedAssetID}
          onClose={() => setShowUploadFileModal(false)}
          onBack={() => {
            setShowUploadFileModal(false);
            setShowUploadExcelModal(true);
          }}
          onChangeFile={handleChangeFile}
          onProceedToFaUploadedFiles={handleProceedToFaUploadedFiles}
        />
      )}

      {showFaUploadedFiles && (
        <FaUploadedFiles
          uploadedFiles={uploadedFiles}
          onBack={() => {
            setShowFaUploadedFiles(false);
            setShowUploadFileModal(true);
          }}
          onAdd={handleAddFiles}
          onStartMapping={handleStartMapping}
          onResetMapping={handleResetMapping}
          onFinish={handleFinish}
          canFinish={canFinish}
          onRemove={handleRemoveFile}
          onClose={() => setShowFaUploadedFiles(false)}
        />
      )}

      {showColumnMapping && (
        <ColumnMapping
          FixedAssetID={fixedAssetID}
          onBack={() => {
            setShowColumnMapping(false);
            setShowFaUploadedFiles(true);
          }}
          onContinue={handleContinueMapping}
          onCancel={() => {
            setShowColumnMapping(false);
          }}
          onClose={() => {
            setShowColumnMapping(false);
          }}
        />
      )}

      {showSubMapping && (
        <Submapping
          FixedAssetID={fixedAssetID}
          onBack={() => {
            setShowSubMapping(false);
            setShowColumnMapping(true);
          }}
          onClose={() => setShowSubmapping(false)}  
          onMapped={handleSubmappingSuccess}
          onSubmitMapping={handleSubmitSubMapping}
        />
      )}

      {showERPModal && (
        <ERPModal
          erpList={erpList}
          selectedCardId={selectedCardId}
          setSelectedCardId={setSelectedCardId}
          isLoading={isErpLoading}
          onClose={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
          }}
          onBack={() => {
            setShowERPModal(false);
            setSelectedCardId(null);
            setShowAddRegisterModal(true);
          }}
          onProceed={handleSuccessERPModal}
        />
      )}

      {showERPSuccessModal && <SyncERPSuccess onClose={handleERPComplete} />}

      {showFilter && (
        <CustomFilter
          onClose={() => setShowFilter(false)}
          onApply={handleApplyFilter}
          filterConfig={filterConfig}
          appliedFilters={appliedFilters}
        />
      )}

      {showPopup && <SyncPopup onClose={() => setShowPopup(false)} />}

      {showAppendReplacePopup && (
        <AppendReplaceFile
          onClose={() => setShowAppendReplacePopup(false)}
          onSelectUploadType={handleAppendReplaceSelect}
        />
      )}

      <SuccessPopup
        isOpen={successPopup.isOpen}
        title={successPopup.title}
        message={successPopup.message}
        onClose={() =>
          setSuccessPopup({ isOpen: false, title: "Success", message: "" })
        }
      />

      <ErrorPopup
        isOpen={errorPopup.isOpen}
        title={errorPopup.title}
        message={errorPopup.message}
        onClose={() =>
          setErrorPopup({ isOpen: false, title: "Error", message: "" })
        }
      />

      <DeletePopup
        isOpen={deletePopup.isOpen}
        title={deletePopup.title}
        message={deletePopup.message}
        onConfirm={handleConfirmDeleteFile}
        onCancel={() =>
          setDeletePopup({
            isOpen: false,
            title: "Are you sure?",
            message: "",
            fileIndex: null,
          })
        }
      />
    </>
  );
};

export default FaHeaders;
